/**
 * @generated SignedSource<<cd0acc4f8aef5e5eb738b9066e2c09d6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DrawingSetStatus = "DRAFT" | "FAILED_PROCESSING" | "PUBLISHED" | "%future added value";
export type MeasureUnit = "FEET" | "METER" | "%future added value";
export type DrawingSetUpdateInput = {
  currentJobId?: string | null | undefined;
  measureUnit: MeasureUnit;
  name: string;
  previousJobId?: string | null | undefined;
  projectId: string;
  status?: DrawingSetStatus | null | undefined;
  tags?: string | null | undefined;
  versionDate?: number | null | undefined;
};
export type updateDrawingSetMutation$variables = {
  id: string;
  input: DrawingSetUpdateInput;
};
export type updateDrawingSetMutation$data = {
  readonly updateDrawingSet: {
    readonly " $fragmentSpreads": FragmentRefs<"drawingSetFragment">;
  } | null | undefined;
};
export type updateDrawingSetMutation = {
  response: updateDrawingSetMutation$data;
  variables: updateDrawingSetMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  },
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateDrawingSetMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DrawingSet",
        "kind": "LinkedField",
        "name": "updateDrawingSet",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "drawingSetFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateDrawingSetMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DrawingSet",
        "kind": "LinkedField",
        "name": "updateDrawingSet",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdById",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "currentJobId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fileName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "previousJobId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "measureUnit",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "tags",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "versionDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "projectId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9cd7b14771f76aa2b38a62e2f8cf8d94",
    "id": null,
    "metadata": {},
    "name": "updateDrawingSetMutation",
    "operationKind": "mutation",
    "text": "mutation updateDrawingSetMutation(\n  $id: ID!\n  $input: DrawingSetUpdateInput!\n) {\n  updateDrawingSet(id: $id, input: $input) {\n    ...drawingSetFragment\n    id\n  }\n}\n\nfragment drawingSetFragment on DrawingSet {\n  id\n  createdAt\n  updatedAt\n  createdById\n  currentJobId\n  fileName\n  previousJobId\n  status\n  name\n  measureUnit\n  tags\n  versionDate\n  projectId\n}\n"
  }
};
})();

(node as any).hash = "ce495dd3dba5f3ce9dc2f18f9faa471b";

export default node;
